import ElitePass from "pages/ElitePass";

const Enum = () => {

};
const ActionType = () => {
  return {
    Marketing: 1,
    Rebate: 2,
    Scancash: 3,
    Innovation: 4,
    ElitePass: 5,
    ScanSourceSelect: 6
  };
};

const CompanyType = () => {
  return {
    Main: 1,
    Resale: 2,
    Subsidiary: 3,
    Cliente: 4
  };
}

const ActionStatus = () => {
  return {
    Pendente: 1,
    AcaoRejeitada: 2,
    EmExecucao: 3,
    EvidenciasAprovadas: 4,
    EvidenciasRejeitadas: 5,
    NFAprovada: 6,
    NFRejeitada: 7,
    AguardandoPagamento: 8,
    Finalizada: 9,
    Cancelada: 10,
    NFsAprovada: 11,
    Reiniciar: 13,
  };
}

const FundType = () => {
  return {
    Marketing: 1,
    Rebate: 2,
    Scancash: 3,
    Innovation: 4,
    ElitePass: 5,
    ScanSourceSelect: 6
  }
}

const FlowType = {
  Marketing: 1,
  Rebate: 2,
  Scancash: 3,
  Innovation: 4,
  ElitePass: 5,
  ScanSourceSelect: 6
}

const ProfileType = {
  Master: 1,
  Client: 2,
  Attendance: 3,
  Resale: 4
};

const AdminProfiles = [1, 2, 48]

const MasterAgentProfiles = [
  46,
  47,
  49,
]

const FY19 = 1
const FY20 = 5
const FY21 = 9
const FY22 = 10
const FY23 = 11
const FY24 = 12
const FY25 = 13

export {
  ActionType,
  CompanyType,
  ActionStatus,
  FundType,
  FlowType,
  ProfileType,
  AdminProfiles,
  MasterAgentProfiles,
  FY19,
  FY20,
  FY21,
  FY22,
  FY23,
  FY24,
  FY25
};

export default Enum;